import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "rightIcon", "children", "background", "color", "borderColor", "borderStyle", "borderWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { getColorProps, getBackgroundProps, getBorderProps } from './helpers';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Label = /*#__PURE__*/React.forwardRef(function Label(_ref, ref) {
  var icon = _ref.icon,
    rightIcon = _ref.rightIcon,
    children = _ref.children,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'text-secondary-default' : _ref$background,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'decorative-theme-white' : _ref$color,
    borderColor = _ref.borderColor,
    borderStyle = _ref.borderStyle,
    borderWidth = _ref.borderWidth,
    htmlProps = _objectWithoutProperties(_ref, _excluded);
  var isPointer = !!htmlProps.onClick;
  var colorProps = getColorProps(color);
  var backgroundProps = getBackgroundProps(background);
  var borderProps = getBorderProps({
    borderColor: borderColor,
    borderStyle: borderStyle,
    borderWidth: borderWidth
  });
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({}, htmlProps), {}, {
    ref: ref,
    className: clsx(styles['label'], isPointer && styles['cursor_pointer'], colorProps.className, backgroundProps.className, borderProps.className),
    style: _objectSpread(_objectSpread(_objectSpread({}, colorProps.style), backgroundProps.style), borderProps.style),
    children: [icon, children && /*#__PURE__*/_jsx("span", {
      children: children
    }), rightIcon]
  }));
});